/** SPA paths of the knowledge base (MODULE-CONTRACTS §2). */
export const wikiHomePath = '/wiki';

export const spacePath = (spaceId: string) => `/wiki/spaces/${encodeURIComponent(spaceId)}`;

export const pagePath = (pageId: string) => `/wiki/pages/${encodeURIComponent(pageId)}`;

export const editPath = (pageId: string) => `${pagePath(pageId)}/edit`;

/** The trash of a space (deleted pages, restore). */
export const trashPath = (spaceId: string) => `${spacePath(spaceId)}/trash`;

/** Page templates of a space. */
export const spaceTemplatesPath = (spaceId: string) => `${spacePath(spaceId)}/templates`;

/** Portal templates (administrators manage them). */
export const portalTemplatesPath = '/wiki/templates';

export const historyPath = (pageId: string, version?: number, compare?: number) => {
  const params = new URLSearchParams();
  if (version) params.set('v', String(version));
  if (compare) params.set('compare', String(compare));
  const query = params.toString();
  return `${pagePath(pageId)}/history${query ? `?${query}` : ''}`;
};

/** Side panel id of a page (`?panel=wiki-page:<id>`). */
export const PAGE_PANEL = 'wiki-page';

const PAGE_LINK = /^\/wiki\/pages\/([0-9a-f-]{36})\/?$/iu;

/** The page id of an in-app link to a page (`/wiki/pages/<id>`), else null. */
export function pageIdFromHref(href: string | null | undefined): string | null {
  if (!href) return null;
  let path = href;
  try {
    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    path = url.pathname;
  } catch {
    return null;
  }
  return PAGE_LINK.exec(path)?.[1] ?? null;
}

/** Whether a link points into this app (relative or same origin) and may be followed with the router. */
export function isInAppHref(href: string | null | undefined): href is string {
  if (!href || href.startsWith('#')) return false;
  try {
    return new URL(href, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}
